import React from 'react';
import Badge, { BadgeBg } from 'components/base/Badge';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';

interface RefundStatusBadgeProps {
  status: number | string;
  className?: string;
}

const RefundStatusBadge: React.FC<RefundStatusBadgeProps> = ({ 
  status, 
  className = ''
}) => {
  const { t } = useTranslation();
  let label: string;
  let badgeType: BadgeBg;
  let icon: string;
  
  // Ensure we have a numeric status
  // Convert string status to number if possible
  const numericStatus = typeof status === 'string' 
    ? parseInt(status, 10) || 0 
    : typeof status === 'number' ? status : 0;
  
  switch (numericStatus) {
  
    case 0:
      label = t('refundsTable.badges.pending');
      badgeType = 'warning';
      icon = 'clock';
      break;
    case 1:
      label = t('refundsTable.badges.processing');
      badgeType = 'info';
      icon = 'refresh-cw';
      break;
    case 2:
      label = t('refundsTable.badges.resolved');
      badgeType = 'success';
      icon = 'check-circle';
      break;
    case 3:
      label = t('refundsTable.badges.declined');
      badgeType = 'danger';
      icon = 'x-circle';
      break;
    case 4:
      label = t('refundsTable.badges.canceled');
      badgeType = 'secondary';
      icon = 'slash';
      break;
    default:
      label = t('common.notAvailable');
      badgeType = 'secondary';
      icon = 'help-circle';
  }
  
  return (
    <Badge
      bg={badgeType}
      variant="phoenix"
      iconPosition="end"
      className={`fs-10 ${className}`}
      icon={
        <FeatherIcon
          icon={icon}
          size={12.8}
          className="ms-1"
        />
      }
    >
      {label}
    </Badge>
  );
};

export default RefundStatusBadge;
